export default __webpack_public_path__ + "assets/images/1c5e997a25acfc83b9d0790138d9a6fe.svg";